import React from 'react';

function CheckIcon() {
  return (
    <svg className="w-5 h-5 shrink-0 text-[#00AAFF]" viewBox="0 0 20 20" fill="currentColor" aria-hidden>
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default function TestimonialsBlock({ content = {} }) {
  const items = content.items || [];
  if (!items.length) return null;

  return (
    <section className="py-8 px-4 sm:px-0 space-y-4">
      {items.map((item, index) => (
        <div
          key={index}
          className="bg-white border border-gray-200 rounded-lg p-5 sm:p-6 shadow-sm"
        >
          <p className="text-sm text-gray-500 mb-2">{item.name}</p>
          {item.result && (
            <div className="flex items-start gap-2 mb-3">
              <CheckIcon />
              <p className="font-bold text-gray-900">{item.result}</p>
            </div>
          )}
          {item.detail && (
            <p className="text-gray-600 text-sm leading-relaxed">{item.detail}</p>
          )}
        </div>
      ))}
    </section>
  );
}
